/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService
 */
import * as References from './PaymentsAccountEligibilityService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getPaymentsAccountEligibility
 */
export const GET_PAYMENTS_ACCOUNT_ELIGIBILITY_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getPaymentsAccountEligibility';
export const GET_PAYMENTS_ACCOUNT_ELIGIBILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAYMENTS_ACCOUNT_ELIGIBILITY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPaymentsAccountEligibilityRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getDefaultPaymentsAccountDetails
 */
export const GET_DEFAULT_PAYMENTS_ACCOUNT_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getDefaultPaymentsAccountDetails';
export const GET_DEFAULT_PAYMENTS_ACCOUNT_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DEFAULT_PAYMENTS_ACCOUNT_DETAILS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getDefaultPaymentsAccountDetailsRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getPaymentsAccountDetails
 */
export const GET_PAYMENTS_ACCOUNT_DETAILS_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getPaymentsAccountDetails';
export const GET_PAYMENTS_ACCOUNT_DETAILS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAYMENTS_ACCOUNT_DETAILS_QUERY_FIELD_NAME,
  args: ['paymentsAccountId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getPaymentsAccountDetailsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getDefaultPublishableKey
 */
export const GET_DEFAULT_PUBLISHABLE_KEY_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getDefaultPublishableKey';
export const GET_DEFAULT_PUBLISHABLE_KEY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DEFAULT_PUBLISHABLE_KEY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getDefaultPublishableKeyRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.accounts.rpc.PaymentsAccountEligibilityService#getDefaultActionEligibility
 */
export const GET_DEFAULT_ACTION_ELIGIBILITY_QUERY_FIELD_NAME = 'com_hubspot_payments_accounts_rpc_PaymentsAccountEligibilityService_getDefaultActionEligibility';
export const GET_DEFAULT_ACTION_ELIGIBILITY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DEFAULT_ACTION_ELIGIBILITY_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getDefaultActionEligibilityRpc, {
      timeout: ctx.timeout
    });
  }
});